import { createSelector } from 'reselect'

import { selectCustomFieldCategories } from 'ducks/crm/customFieldCategories'
import { selectSidebarCardIntegrations } from 'selectors/sidebar_cards'

export const selectContactDetailsColumnWidgetCards = createSelector(
  selectCustomFieldCategories,
  selectSidebarCardIntegrations,
  (categories, integrations) => {
    return [...integrations, ...categories]
  }
)
